import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const DeliveryHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.buyCar?.deliverySection?.header || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-12 md:mb-16"
    >
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
        {headerData.title || "Flexibel Leverans & Betalning"}
      </h2>
      <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
        {headerData.description ||
          "Välj hur du vill få din bil - hämta på station eller få den levererad hem."}
      </p>
    </motion.div>
  );
};

export default DeliveryHeader;
